module.exports = __webpack_public_path__ + "img/USDT-icon.83b3fc68.svg";